import { IPrimitiveProperties } from '@notes/aria-common-schema-logger'
import { PrimitiveProperties } from '@notes/webintegrations-common'
import { LocalizationService } from '../../localization/LocalizationService'
import { GlobalVariables } from '../GlobalVariables'

export function buildContext(context: PrimitiveProperties = {}): PrimitiveProperties {
  const commonContext = {
    SessionId: GlobalVariables.environmentSettings.sessionId,
    CorrelationId: GlobalVariables.environmentSettings.correlationId,
    Ring: GlobalVariables.environmentSettings.ring,
    Version: GlobalVariables.environmentSettings.version,
    Language: LocalizationService.areLocalizationValuesReady ? LocalizationService.locale : 'LOCALE NOT AVAILABLE YET',
    TextDirection: LocalizationService.areLocalizationValuesReady ? LocalizationService.textDirection : 'TEXT DIRECTION NOT AVAILABLE YET',
  }
  return {
    ...context,
    ...commonContext,
  }
}

export function buildEnvironmentSettingsContext(): IPrimitiveProperties {
  const environmentSettings = GlobalVariables.environmentSettings
  return {
    SessionId: environmentSettings.sessionId,
    CorrelationId: environmentSettings.correlationId,
    Ring: environmentSettings.ring,
    Version: environmentSettings.version,
  }
}
